import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { DEALER } from "@/data/dealer";
import { NAV } from "@/components/layout/nav";
import { LogoImg } from "@/components/layout/Logo";

const FooterHeading = ({ children }) => <h2 className="mb-5 text-xs font-bold uppercase tracking-[0.2em] text-white">{children}</h2>;

export const Footer = () => (
  <footer className="on-dark bg-ink text-zinc-300" data-testid="site-footer">
    <div className="container-x grid gap-12 py-16 lg:grid-cols-12 lg:py-20">
      <div className="space-y-6 lg:col-span-4">
        <div className="inline-flex rounded-md bg-white px-4 py-3">
          <LogoImg className="h-7" />
        </div>
        <p className="max-w-xs text-sm leading-relaxed">
          Family-run used car dealership in Peterborough, rated {DEALER.rating.score} on AutoTrader from {DEALER.rating.reviews} customer reviews.
        </p>
        <a
          href={DEALER.autotrader.profile}
          target="_blank"
          rel="noopener noreferrer"
          className="link-underline inline-flex items-center gap-1.5 text-sm font-semibold text-white"
          data-testid="footer-autotrader-link"
        >
          YK Motors on AutoTrader <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
        </a>
      </div>
      <nav aria-label="Footer" className="lg:col-span-2">
        <FooterHeading>Explore</FooterHeading>
        <ul className="space-y-3 text-sm">
          {NAV.map((n) => (
            <li key={n.to}>
              <Link to={n.to} className="link-underline hover:text-white" data-testid={`footer-nav-${n.id}-link`}>
                {n.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <div className="lg:col-span-3">
        <FooterHeading>Visit & contact</FooterHeading>
        <address className="space-y-3 text-sm not-italic leading-relaxed">
          <p>
            {DEALER.address.line1}
            <br />
            {DEALER.address.town}, {DEALER.address.postcode}
          </p>
          <p>
            <a href={DEALER.phone.href} className="link-underline font-semibold text-white" data-testid="footer-phone-link">
              {DEALER.phone.display}
            </a>
          </p>
          <p>
            <a href={`mailto:${DEALER.email}`} className="link-underline hover:text-white" data-testid="footer-email-link">
              {DEALER.email}
            </a>
          </p>
          <p>
            <a href={DEALER.mapsUrl} target="_blank" rel="noopener noreferrer" className="link-underline inline-flex items-center gap-1 hover:text-white" data-testid="footer-directions-link">
              Get directions <ArrowUpRight className="h-3.5 w-3.5" aria-hidden="true" />
            </a>
          </p>
        </address>
      </div>
      <div className="lg:col-span-3">
        <FooterHeading>Opening hours</FooterHeading>
        <dl className="space-y-2 text-sm">
          {DEALER.hours.map((h) => (
            <div key={h.day} className="flex justify-between gap-4">
              <dt>{h.day}</dt>
              <dd className="tabular-nums text-white">{h.hours}</dd>
            </div>
          ))}
        </dl>
        <p className="mt-4 text-xs leading-relaxed text-zinc-400">Viewings by appointment only.</p>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="container-x flex flex-col gap-2 py-6 text-xs text-zinc-400 md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} YK Motors. All rights reserved.</p>
        <p>Stock updates hourly from our AutoTrader adverts.</p>
      </div>
    </div>
  </footer>
);
